<template>
  <div class="productWrapper">
    <div class="pcWrapper" v-if="!isMobile">
      <div class="firstWrapper">
        <img src="https://img.i2soft.net/i2official-web/v2/assets/images/product/firstBack.png" alt="艾融软件-创新产品" />
      </div>
      <ProductSection
        title="量子加密机"
        subhead="基于量子密钥基础设施自研国密密码服务器"
        productImage="https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_quantum.png"
        :iconData="secondData"
        detailType="quantum"
        :iconColumns="5"
        @view-details="seeProdDetail"
      />
      <ProductSection
        title="AI生物识别反诈一体机"
        subhead="基于国产信创服务器和国产大模型的生物识别反欺诈一体机"
        productImage="https://img.i2soft.net/i2official-web/v2/assets/images/product/third_prod_ai.png"
        :iconData="thirdData"
        detailType="ai"
        wrapperClass="thirdWrapper"
        :iconColumns="3"
        @view-details="seeProdDetail"
      />
    </div>
    <ProductDetailDialog
      :visible="prodModelInfo.showModel"
      :title="prodModelInfo.title"
      :type="prodModelInfo.type"
      :quantumInfo="quantumDialogData" 
      @close="closeProdModel"
     />
  </div>
</template>

<script>
import ProductSection from './ProductSection.vue';
import ProductDetailDialog from './ProductDetailDialog.vue';
import { isMobile } from "@/utils/index";

export default {
  components: {
    ProductSection,
    ProductDetailDialog,
  },
  data() {
    return {
      isMobile: false,
      prodModelInfo: {
        showModel: false,
        type: '',
        title: '产品介绍',
      },
      secondData: [
        {
          name: "自主可控",
          intro:
            "纯国产处理器及国产操作系统，确保信息安全自主可控",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_icon1.svg",
        },
        {
          name: "安全",
          intro:
            "应用密钥在密码机内加密存储、密钥管理规范三层密钥保护结构、“背靠背”分量管理机制、防辐射防探测防御常见网络攻击",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_icon2.svg",
        },
        {
          name: "易操作",
          intro:
            "支持通过 B/S 方式对设备进行配置管理，支持系统管理、密钥管理、权限管理、固件升级等",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_icon3.svg",
        },
        {
          name: "强适配",
          intro:
            "支持多种语言编程接口（C、JAVA），支持 Windows、Linux 等多种主流操作系统平台，方便与应用系统集成",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_icon4.svg",
        },
        {
          name: "大容量",
          intro: "支持存储对称密钥与 SM2 密钥对共 10000 组",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_icon5.svg",
        },
      ],
      thirdData: [
        {
          name: "自主可控",
          intro: "CPU处理器及操作系统、国产算力芯片、人工智能大模型基础软件全部采用国产，全面自主可控",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/third_prod_icon1.svg",
        },
        {
          name: "多个大模型应用适配",
          intro: "适配和应用了多个文本大模型和图像大模型，包括豆包、千问、DeepSeek V3 和 R1 模型",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/third_prod_icon2.svg",
        },
        {
          name: "视觉大模型和文本大模型融合应用",
          intro: "不依赖单一厂家大模型，选用图像识别结构化效果最佳的视觉大模型和交易文本数据特征提取最佳文本大模型，综合图像和文本数据构建最优的多模态欺诈特征识别大模型应用",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/third_prod_icon3.svg",
        },
        {
          name: "基于大模型精准识别人像欺诈行为",
          intro: "大模型通过人脸外貌多维度特征识别大数据分析，结合交易行为大数据分析，更精准的阻断AI伪造人像欺诈交易，解决现有生物识别系统活体检测和人脸比对算法安全性和准确性不足，易被攻击骗过的风险",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/third_prod_icon4.svg",
        },
        {
          name: "内置对接权威AI人脸欺诈情报",
          intro: "通过公安部身份核验系统的AI人脸欺诈情报数据支持，可实时阻断情报命中的可疑交易，人脸欺诈交易识别更准确灵敏",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/third_prod_icon5.svg",
        },
        {
          name: "快速部署",
          intro: "一体化交付硬件、大模型和预训练生物识别反欺诈应用模型，实现快速低成本交付",
          imgUrl: "https://img.i2soft.net/i2official-web/v2/assets/images/product/third_prod_icon6.svg",
        },
      ],
      // 量子加密机-产品信息（弹窗）
      prod_qiantumInfo: {
        // 表格数据
        table: [
          {
            name: 'SM1算法',
            target: '加解密性能>600Mbps',
          },
          {
            name: 'SM2签名',
            target: '>80000次/秒',
          },
          {
            name: 'SM2验签',
            target: '>30000次/秒',
          },
          {
            name: 'SM2密钥对生成',
            target: '>100000对/秒',
          },
          {
            name: 'SM3算法',
            target: '>800Mbps',
          },
          {
            name: 'SM4算法',
            target: '加解密性能>800Mbps',
          },
          {
            name: 'SM9算法',
            target: '加解密性能>135Mbps',
          },
          {
            name: '密码微电保护',
            target: '时间>10年',
          },
        ],
        // 电源设计数据
        powerDesign: `工业级冗余双电源设计;
        输入电源范围:AC190~240V,50~60HZ;
        工作温度范围:0~40℃;
        存储温度范围:-40~55℃;
        工作湿度要求:<90%/40℃;
        存储湿度要求:<93%/40℃;
        功耗:<100W;
        外形尺寸:标准1U;
        整机质量:≤10KG(标准配置);
        接口适配性:4个千兆(1Gbps)光纤接口,5个100/1000Mbps自适应以太网电接口;
        配置口:RJ45 口,配有专用串口配置线,用于设备维护;
        USB 口:1个,用于身份认证;
        内存:8G;
        硬盘:256G。`
      }
    };
  },
  computed: {
    quantumDialogData() {
        if (this.prodModelInfo.type === 'quantum') {
            return {
                ...this.prod_qiantumInfo,
                powerDesignArr: this.strTransformArr(this.prod_qiantumInfo.powerDesign)
            };
        }
        return null;
    }
  },
  mounted() {
    this.isMobile = isMobile();
    window.addEventListener("scroll", this.getScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
  methods: {
    getScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 70
      ) {
        this.$store.commit("TO_AfterScroll");
      } else {
        this.$store.commit("TO_AfterScroll_false");
      }
    },

    seeProdDetail(type) {
      console.log('查看详情', type);
      this.prodModelInfo.showModel = true;
      this.prodModelInfo.type = type;
      if (type == 'quantum') {
        this.prodModelInfo.title = '量子加密机产品介绍';
      } else {
        this.prodModelInfo.title = 'AI生物识别反诈一体机产品介绍';
      }

    },
    strTransformArr(str) {
      if (!str) {
        return []
      }
      var finalArr = str.split(';');
      finalArr = finalArr.map(item => item.trim() + ';');
      if (finalArr.length > 0) {
        finalArr[finalArr.length - 1] = finalArr[finalArr.length - 1].slice(0, -1);
      }
      return finalArr;
    },
    closeProdModel() {
      this.prodModelInfo.showModel = false;
    }
  },
};
</script>

<style lang="less" scoped>
.productWrapper {
  background: #ffffff;

  .pcWrapper {
    .firstWrapper {
      position: relative;
      img {
        margin: 0 auto;
        display: block;
        width: 100%;
        height: auto;
      }
    }
    .thirdWrapper {
       background: #F1F1F1;
    }
  }
}
</style>
